/* Bhairav Tatva — remove a configured gemstone and its setting / certificate lines together.
   Horizon's cart removes one line (/cart/change, quantity 0). GemJohri's helper (gemstone-cart-bundle.js)
   then notices the orphaned setting / certificate lines and removes them in a second round trip, so they
   linger for a moment. Here, when the line being removed is a configured stone (_gj_bundle_id + _gj_form),
   the same request is sent as one /cart/update with every line of that bundle set to 0. The response has
   the same shape (cart JSON + requested sections), so Horizon renders it as usual and GemJohri's clean-up
   finds nothing left to do. Anything else passes through untouched. */
(function () {
  'use strict';
  if (window.fetch && window.fetch.__btBundleFast) return;

  const nativeFetch = window.fetch;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const strip = (p) => String(p || '').replace(/\.js$/, '').replace(/\/$/, '');

  function routes() {
    const r = (window.Theme && window.Theme.routes) || {};
    return {
      change: strip(r.cart_change_url || `${root}cart/change`),
      update: r.cart_update_url || `${root}cart/update`,
    };
  }

  function props(item) {
    const raw = (item && item.properties) || {};
    if (!Array.isArray(raw)) return raw;
    const out = {};
    raw.forEach((e) => { if (e && e.name) out[e.name] = e.value; });
    return out;
  }

  async function bundleUpdates(body) {
    const cart = await nativeFetch.call(window, `${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const items = (cart && cart.items) || [];
    let item = null;
    if (body.line) item = items[Number(body.line) - 1];
    else if (body.id) item = items.find((i) => i.key === String(body.id)) || items.find((i) => String(i.id) === String(body.id));
    if (!item) return null;
    const p = props(item);
    const bid = p._gj_bundle_id;
    if (!bid || !(p._gj_form || p.Form) || p._gj_component) return null;
    const updates = {};
    items.forEach((i) => { if (props(i)._gj_bundle_id === bid) updates[i.key] = 0; });
    return Object.keys(updates).length > 1 ? updates : null;
  }

  window.fetch = async function btBundleFast(input, init) {
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && init && typeof init.body === 'string') {
        const path = strip(new URL(url, window.location.origin).pathname);
        const r = routes();
        if (path === r.change) {
          const body = JSON.parse(init.body);
          if (body && Number(body.quantity) === 0 && (body.line || body.id)) {
            const updates = await bundleUpdates(body);
            if (updates) {
              const next = Object.assign({}, body, { updates });
              delete next.line;
              delete next.id;
              delete next.quantity;
              return nativeFetch.call(window, r.update, Object.assign({}, init, { body: JSON.stringify(next) }));
            }
          }
        }
      }
    } catch (e) {
      /* fall through to the original request */
    }
    return nativeFetch.call(window, input, init);
  };
  window.fetch.__btBundleFast = true;
})();
